import { render, staticRenderFns } from "./MixedTeamScorecard.vue?vue&type=template&id=2511ae32&scoped=true&"
import script from "./MixedTeamScorecard.vue?vue&type=script&lang=js&"
export * from "./MixedTeamScorecard.vue?vue&type=script&lang=js&"
import style0 from "./MixedTeamScorecard.vue?vue&type=style&index=0&id=2511ae32&lang=scss&scoped=true&"
import style1 from "./MixedTeamScorecard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511ae32",
  null
  
)

export default component.exports